export default __webpack_public_path__ + "static/media/Karthikh Amaran.c1a72666.png";